import { useState } from 'react';

/**
 * The collapsible date filter overlay used on the run maps.
 * Ported from the markup + toggle/translate logic in page-run-map.php.
 * Calls `onFilter('year.month.day.hour')` where each empty field becomes -1.
 */
export default function MapFilter({ onFilter }) {
  const [open, setOpen] = useState(false);
  const [year, setYear] = useState('');
  const [month, setMonth] = useState('');
  const [day, setDay] = useState('');
  const [hour, setHour] = useState('');

  const translateDate = () =>
    `${year || '-1'}.${month || '-1'}.${day || '-1'}.${hour || '-1'}`;

  const selectDate = () => onFilter(translateDate());

  const resetMapFilter = () => {
    setYear('');
    setMonth('');
    setDay('');
    setHour('');
    onFilter('-1.-1.-1.-1');
  };

  return (
    <div id="selectorDiv">
      <div id="selectorToggle">
        <button onClick={() => setOpen((o) => !o)}>
          Filter{' '}
          {open ? (
            <i className="arrow up" style={{ display: 'inline-block' }}></i>
          ) : (
            <i className="arrow down"></i>
          )}
        </button>
      </div>
      {open && (
        <div id="dateSelector">
          <table>
            <thead>
              <tr>
                <th>Year</th>
                <th>Month</th>
                <th>Day</th>
                <th>Hour</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <input type="text" value={year} onChange={(e) => setYear(e.target.value)} />
                </td>
                <td>
                  <input type="text" value={month} onChange={(e) => setMonth(e.target.value)} />
                </td>
                <td>
                  <input type="text" value={day} onChange={(e) => setDay(e.target.value)} />
                </td>
                <td>
                  <input type="text" value={hour} onChange={(e) => setHour(e.target.value)} />
                </td>
              </tr>
            </tbody>
          </table>
          <button onClick={selectDate}>Find Runs</button>
          <button onClick={resetMapFilter}>Reset</button>
          <p id="errorMessage"></p>
        </div>
      )}
    </div>
  );
}
